import { useQuery } from "react-query";
import { fetchAutoPopulationFields, fetchPopulateLetter } from "@/services/letter";
/** Query hook for a patient's path-keyed populate values (optionally for a report). */
export function usePopulateLetter(workspaceId, patientUid, reportId) {
  return useQuery(["letter-populate", workspaceId, patientUid, reportId !== null && reportId !== void 0 ? reportId : "base"], function () {
    return fetchPopulateLetter(workspaceId, patientUid, reportId);
  }, {
    enabled: Boolean(workspaceId) && Boolean(patientUid)
  });
}

/** Query hook for the workspace's auto-population fields. */
export function useAutoPopulationFields(workspaceId) {
  return useQuery(["auto-population-fields", workspaceId], function () {
    return fetchAutoPopulationFields(workspaceId);
  }, {
    enabled: Boolean(workspaceId)
  });
}